import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_05_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-05-01",
    "name": "青蛙趴激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "hip-leg",
    "tips": ["蛙式下蹲+动态弹动，打开髋内收", "膝盖打开对准脚尖，重心下沉"],
    "sets": 2,
    "reps": "15",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "焚诀计划 · 第5期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-3ab30d6082e1ca16be5774fc.mp4",
    "videoUrl": "/media/collections-20261008/videos/9493fcb37c62036ee128a2c4.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-05-02",
    "name": "保加利亚蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "quadriceps",
    "tips": ["前腿膝盖不超脚尖", "重心在前脚"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/7e235190f6bb87dac3660fa7.mp4",
    "videoUrl": "/media/collections-20261008/videos/1be69483f1c94bd048ab9503.mp4",
    "targetMuscles": ["股四头肌", "臀大肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第5期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
